import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Table } from "../../../features/Table";
import { type A5PdfPageSelection, columns } from "./columns";
import {
  type FilterA5PdfPageSelectionSchema,
  A5PdfPageSelectionFilter,
} from "./filter";

export const A5PdfPageSelectionTable = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("tables");
  const client = searchParams.get("client") || "a5";
  const tableName = "a5_pdf_page_selection";

  return (
    <Table<A5PdfPageSelection, FilterA5PdfPageSelectionSchema>
      label={t("a5_pdf_page_selection.title", { defaultValue: "PDF page selection" })}
      client={client}
      table_name={tableName}
      columns={columns}
      filter={<A5PdfPageSelectionFilter />}
      disable_translations_request={true}
      columnVisibilityInit={{
        tableau_view: false,
        tableau_workbook_id: false,
        created_at: false,
      }}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${tableName}/new`,
        },
      ]}
    />
  );
};
